import React, { useState } from "react";
import { FilterMode } from "./Filtermode";
import BasicGrid from "./Grid";

const LiquidationBarcodeListForApprove =()=>{
    const [payload, setPayload] = useState(null);
    return(
        <>
        <FilterMode onPayloadChange={setPayload}/>
             <BasicGrid payload={payload} />
        </>
    )
};

export default LiquidationBarcodeListForApprove;